/**
 * 展示层格式化工具。
 *
 * 金额/数量在后端以字符串（TEXT）返回，避免前端浮点误差；
 * 此处提供安全的展示格式化方法，供页面层复用。
 *
 * @module utils/format
 */

/**
 * 格式化金额（字符串）为带千分位与固定小数的展示文本。
 *
 * @param value 金额（字符串或数字）。
 * @param fractionDigits 小数位数，默认 2。
 * @returns 本地化展示文本。
 */
export function formatMoney(
  value: string | number,
  fractionDigits = 2,
): string {
  const num = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(num)) return (0).toFixed(fractionDigits);
  return num.toLocaleString('zh-CN', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

/**
 * 格式化数字为千分位展示文本。
 *
 * @param value 数字或数字字符串。
 * @returns 本地化展示文本。
 */
export function formatNumber(value: number | string): string {
  const num = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(num)) return '0';
  return num.toLocaleString('zh-CN');
}
